import "../TestimonialsPage.css";

function TestimonialsPage() {
  const testimonials = [
    {
      id: 1,
      name: "John Doe",
      role: "Customer",
      image: "/assets/insta-1.jpg",
      text: "This is the best online store I’ve ever used. The products are top quality and delivery was super fast!",
    },
    {
      id: 2,
      name: "Chris Smith",
      role: "Customer",
      image: "/assets/test-4.jpg",
      text: "Amazing experience! Great prices, easy checkout, and excellent customer service.",
    },
    {
      id: 3,
      name: "Michael Lee",
      role: "Customer",
      image: "/assets/test-3.jpg",
      text: "I love shopping here. The website is smooth and the products exceeded my expectations!",
    },
    {
      id: 4,
      name: "Lisa Johnson",
      role: "Customer",
      image: "/assets/insta-2.jpg",
      text: "Beautiful website, responsive support team, and great deals!",
    },
  ];

  return (
    <div className="testimonials-page py-5">
      <div className="container">
        <h2 className="fw-bold text-center main-color mb-4">
          What Our Customers Say
        </h2>
        <p className="text-center text-muted mb-5">
          We value every opinion from our customers — here’s what they think about us.
        </p>

        <div className="row g-4">
          {testimonials.map((t) => (
            <div key={t.id} className="col-md-6 col-lg-4">
              <div className="testimonial-card text-center p-4 shadow-sm rounded-4 h-100">
                <img
                  src={t.image}
                  alt={t.name}
                  className="testimonial-img mb-3 rounded-circle"
                />
                <p className="testimonial-text fst-italic text-muted">“{t.text}”</p>
                <h5 className="testimonial-name mt-3 fw-bold">{t.name}</h5>
                <span className="testimonial-role text-secondary small">
                  {t.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TestimonialsPage;
